import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[ngxSummernoteView]',
    standalone: false
})
export class SummernoteViewDirective implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef<HTMLElement>
  ) {}

  @Input()
  set ngxSummernoteView(content: string | null | undefined) {
    this.elementRef.nativeElement.innerHTML = content || '';
  }

  ngAfterViewInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'ngx-summernote-view');
  }
}